module.exports = __webpack_public_path__ + "img/email.fff67bb3.png";